import { useState, useEffect, createContext, useContext } from 'react'
import { SafeProvider, createConfig } from '@safe-global/safe-react-hooks'
import { useAccount, useWalletClient } from 'wagmi'
import { CLIENT_SAFE, SAFE_TX_SERVICE_URLS } from 'src/constants/networks'
import ConnectWallet from 'src/components/environmentConfig/ConnectWallet'

const SafeConfigContext = createContext(null)

export const SafeConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null)
  const { address: connectedAddress, chain, connector } = useAccount()
  const { data: walletClient, status } = useWalletClient()

  useEffect(() => {
    const setupSafeConfig = async () => {
      if (!chain || !connectedAddress || status !== 'success' || !walletClient || !connector) {
        console.warn("Can't initialize SafeConfig")
        return
      }

      const txServiceUrl = SAFE_TX_SERVICE_URLS[chain.id]
      if (!txServiceUrl) {
        console.warn(`No Safe transaction service for chainId ${chain.id}`)
        return
      }

      try {
        const safeConfig = createConfig({
          chain: chain,
          provider: walletClient.transport,
          signer: connectedAddress,
          safeAddress: CLIENT_SAFE[chain.id],
          txServiceUrl,
        })

        setConfig(safeConfig)
      } catch (error) {
        console.error('Error configurando Safe:', error)
      }
    }

    setupSafeConfig()
  }, [chain, connectedAddress, status, walletClient, connector])

  if (!config) {
    return (
      <>
        <br/>
        <ConnectWallet />
        <p>Loading SafeConfig...</p>
      </>
    )
  }

  return (
    <SafeConfigContext.Provider value={{ ...config }}>
      <SafeProvider config={config}>{children}</SafeProvider>
    </SafeConfigContext.Provider>
  )
}

export const useSafeConfig = () => useContext(SafeConfigContext)
